import styled from "@emotion/styled";
import { theme } from "../../../utils/Theme";

export const Container = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
  gap: 4px;
`;

export const Label = styled.label``;

export const Radio = styled.input`
  display: none;
`;
